if (!customElements.get('product-video-reel')) {
  customElements.define(
    'product-video-reel',
    class ProductVideoReel extends HTMLElement {
      connectedCallback() {
        if (this.dataset.videoReelReady === 'true') return;

        this.dataset.videoReelReady = 'true';
        this.track = this.querySelector('[data-product-video-track]');
        this.controls = this.querySelector('[data-product-video-controls]');
        this.modal = this.querySelector('[data-product-video-modal]');
        this.modalPlayer = this.querySelector('[data-product-video-modal-player]');
        this.modalTitle = this.querySelector('[data-product-video-modal-title]');
        this.handleClickBound = this.handleClick.bind(this);
        this.handleCloseBound = this.cleanupModal.bind(this);
        this.updateControlsBound = this.updateControls.bind(this);

        this.addEventListener('click', this.handleClickBound);
        this.modal?.addEventListener('close', this.handleCloseBound);
        window.addEventListener('resize', this.updateControlsBound, { passive: true });

        if (typeof ResizeObserver !== 'undefined' && this.track) {
          this.resizeObserver = new ResizeObserver(this.updateControlsBound);
          this.resizeObserver.observe(this.track);
        }

        this.updateControls();
      }

      disconnectedCallback() {
        delete this.dataset.videoReelReady;
        this.removeEventListener('click', this.handleClickBound);
        this.modal?.removeEventListener('close', this.handleCloseBound);
        window.removeEventListener('resize', this.updateControlsBound);
        this.resizeObserver?.disconnect();
        this.cleanupModal();
      }

      handleClick(event) {
        const previous = event.target.closest('[data-product-video-previous]');
        if (previous && this.contains(previous)) {
          this.scrollTrack(-1);
          return;
        }

        const next = event.target.closest('[data-product-video-next]');
        if (next && this.contains(next)) {
          this.scrollTrack(1);
          return;
        }

        const close = event.target.closest('[data-product-video-modal-close]');
        if (close && this.contains(close)) {
          this.closeModal();
          return;
        }

        if (event.target === this.modal) {
          this.closeModal();
          return;
        }

        const opener = event.target.closest('[data-product-video-open]');
        if (opener && this.contains(opener)) this.openModal(opener);
      }

      scrollTrack(direction) {
        if (!this.track) return;
        const distance = Math.max(this.track.clientWidth * 0.82, 180);
        this.track.scrollBy({ left: distance * direction, behavior: 'smooth' });
      }

      updateControls() {
        if (!this.track || !this.controls) return;
        this.controls.hidden = this.track.scrollWidth <= this.track.clientWidth + 2;
      }

      openModal(opener) {
        const sourceVideo = opener.querySelector('video');
        if (!sourceVideo || !this.modal || !this.modalPlayer) return;

        this.cleanupModal();
        const player = sourceVideo.cloneNode(true);
        player.controls = true;
        player.autoplay = false;
        player.loop = false;
        player.muted = false;
        player.removeAttribute('autoplay');
        player.removeAttribute('loop');
        player.removeAttribute('muted');
        player.setAttribute('playsinline', '');
        player.preload = 'metadata';
        this.modalPlayer.replaceChildren(player);

        if (this.modalTitle) this.modalTitle.textContent = opener.dataset.videoTitle || 'Video';

        if (typeof this.modal.showModal === 'function') {
          this.modal.showModal();
        } else {
          this.modal.setAttribute('open', '');
        }

        player.play().catch(() => {});
      }

      closeModal() {
        if (!this.modal) return;
        if (typeof this.modal.close === 'function' && this.modal.open) {
          this.modal.close();
        } else {
          this.modal.removeAttribute('open');
          this.cleanupModal();
        }
      }

      cleanupModal() {
        const player = this.modalPlayer?.querySelector('video');
        if (player) {
          player.pause();
          player.removeAttribute('src');
          player.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
          player.load();
        }
        this.modalPlayer?.replaceChildren();
      }
    }
  );
}
